import React from 'react'
import THEME from 'utils/theme'

export default function LinkIcon({ color = THEME.COLORS.TEXTCOLOR, width = '18px', height = '18px' }) {
  return (
    <svg
      aria-labelledby='copy-link'
      viewBox='0 0 19 19'
      className='svgIcon iconLink'
      style={{ width, height, fill: color }}
    >
      <title id='copy-link'>Copy Link</title>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.6396 12.0021L16.9162 8.7266C18.7248 6.91755 18.7248 3.98412 16.9162 2.17504C15.1067 0.365887 12.1737 0.365887 10.3642 2.17504L7.88209 4.65705C8.87346 4.51177 9.89184 4.61073 10.8371 4.97878L12.0019 3.81272C12.9056 2.90965 14.3748 2.90965 15.2775 3.81272C16.1813 4.71579 16.1813 6.18505 15.2775 7.0888L12.0019 10.3643C11.0993 11.2669 9.62965 11.2681 8.7265 10.3643C8.4437 10.0814 8.25996 9.74099 8.1547 9.38138C8.1383 9.39085 8.12175 9.40004 8.1052 9.40922C8.0356 9.44787 7.96604 9.48649 7.90756 9.54545L6.3851 11.0678C6.58083 11.3979 6.80372 11.718 7.08863 12.0021C8.89737 13.8116 11.8311 13.8116 13.6396 12.0021ZM7.08859 15.2788L8.25423 14.1127C9.19866 14.4801 10.2173 14.5799 11.2092 14.4337L8.72646 16.9163C6.91734 18.7249 3.98401 18.7249 2.17485 16.9163C0.365872 15.1067 0.365872 12.1742 2.17485 10.3645L5.45033 7.08888C7.25949 5.27972 10.1935 5.27972 12.0018 7.08888C12.2868 7.37329 12.5108 7.69226 12.7053 8.02369L11.183 9.54542C11.1257 9.60282 11.0583 9.64021 10.9901 9.67809C10.9723 9.68802 10.9543 9.69798 10.9365 9.70834C10.8302 9.34919 10.6463 9.00883 10.3641 8.7266C9.46108 7.82292 7.99239 7.82292 7.08859 8.7266L3.81261 12.0021C2.90946 12.9056 2.90946 14.3749 3.81261 15.2788C4.71583 16.1814 6.18551 16.1814 7.08859 15.2788Z'
        fill='white'
      />
    </svg>
  )
}
